const notImplemented = (methodName) => {
  return Promise.reject(`${methodName} is not implemented`);
};

class BaseBreakoutRoomsProvider {
  async getConfiguration() {
    return notImplemented("getConfiguration");
  }
}

export default BaseBreakoutRoomsProvider;
